/*
* default prefix "AUTO_BACKUP"
* */

export const AT_AUTO_BACKUP_SET = 'AUTO_BACKUP_AUTOBACKUP_SET_ACTION';
export const AT_AUTO_BACKUP_BACKUP_SCHEDULE_SET = 'AUTO_BACKUP_BACKUP_SCHEDULE_SET_ACTION';
